const r = (m) => m.default || m;

export const Icons = {
  "TV Subscriptions": r(require("../Assets/service-icons/TV Subscriptions.jpg")),
  "Home Insurance": r(require("../Assets/service-icons/Home Insurance.jpg")),
  "Pet Insurance": r(require("../Assets/service-icons/Pet Insurance.jpg")),
  Vet: r(require("../Assets/service-icons/Vets.jpg")),
  Loans: r(require("../Assets/service-icons/Loans.jpg")),
  "Private Pension": r(require("../Assets/service-icons/Private Pensions.jpg")),
  "Premium Bonds": r(require("../Assets/service-icons/Premium Bonds.jpg")),
  "Digital Subscriptions": r(require("../Assets/service-icons/Digital Subcriptions.jpg")),
  Council: r(require("../Assets/service-icons/Council.jpg")),
  "Health Insurance": r(require("../Assets/service-icons/Health Insurance.jpg")),
  Accountant: r(require("../Assets/service-icons/Accountants.jpg")),
  University: r(require("../Assets/service-icons/University.jpg")),
  Broadband: r(require("../Assets/service-icons/Broadband.jpg")),
  Dentist: r(require("../Assets/service-icons/Dentists.jpg")),
  School: r(require("../Assets/service-icons/Schools.jpg")),
  Energy: r(require("../Assets/service-icons/Energy.jpg")),
  Bank: r(require("../Assets/service-icons/Banking.jpg")),
  Vehicle: r(require("../Assets/service-icons/Vehicle.jpg")),
  Solicitor: r(require("../Assets/service-icons/Solicitors.jpg")),
  "HMRC": r(require("../Assets/service-icons/Inland Revenue.jpg")),
  "Inland Revenue": r(require("../Assets/service-icons/Inland Revenue.jpg")),
  Water: r(require("../Assets/service-icons/Water Icon.svg")),
  "Magazine Subscriptions": r(require("../Assets/service-icons/Magazine Subscriptions.jpg")),
  Optician: r(require("../Assets/service-icons/Opticians.jpg")),
  Doctor: r(require("../Assets/service-icons/Doctors-08.jpg")),
  "Life Insurance": r(require("../Assets/service-icons/Life Insurance.jpg")),
  "Store Cards": r(require("../Assets/service-icons/Store Cards.jpg")),
  Electoral: r(require("../Assets/service-icons/Electrol.jpg")),
  Employer: r(require("../Assets/service-icons/Employer.jpg")),
  "Gym & Health Club": r(require("../Assets/service-icons/Gyms _ Health Clubs.jpg")),
  Pharmacy: r(require("../Assets/service-icons/Phamacy.jpg")),
  "Blood Donation": r(require("../Assets/service-icons/Blood Donation.svg")),
  "Professional Body": r(require("../Assets/service-icons/Professional Bodies.svg")),
  Charity: r(require("../Assets/service-icons/Charities.svg")),
  "Breakdown Cover": r(require("../Assets/service-icons/Breakdown Cover-24.svg")),
  "DVLA": r(require("../Assets/service-icons/DVLA.svg")),
  "Government": r(require("../Assets/service-icons/Government.svg")),
  "Loyalty Cards": r(require("../Assets/service-icons/Loyalty Cards.svg")),
};
